import { STRINGS } from '../constants/strings'
import LegalPage from './legalPage'

export default function TermsPage() {
  return <LegalPage content={STRINGS.terms} />
}
